import {
  buildCustomBackgroundLayers,
  normalizeAppBackgroundCustom,
  normalizeAppBackgroundTheme,
} from "@/lib/appBackgroundThemes";

/**
 * Capa decorativa fija detrás del contenido. pointer-events-none: no afecta clics ni flujos.
 */
export default function AppBackgroundLayer({ theme = "none", custom = null }) {
  const id = normalizeAppBackgroundTheme(theme);
  if (id === "none") return null;

  if (id === "custom") {
    const layers = buildCustomBackgroundLayers(custom);
    return (
      <div
        className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
        aria-hidden
        data-testid="app-background-layer"
        data-theme="custom"
        data-palette={layers.custom.palette}
        data-texture={layers.custom.texture}
        data-intensity={layers.custom.intensity}
      >
        <div className="absolute inset-0" style={layers.baseStyle} />
        {layers.blobs.map((blob, idx) => (
          <div key={`blob-${idx}`} style={blob.style} />
        ))}
        {layers.geometry.map((geo, idx) => (
          <div key={`geo-${idx}`} style={geo.style} />
        ))}
        {layers.overlayStyle ? <div style={layers.overlayStyle} /> : null}
      </div>
    );
  }

  return (
    <div
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
      aria-hidden
      data-testid="app-background-layer"
      data-theme={id}
    >
      {id === "contable_azul" ? (
        <>
          <div className="absolute inset-0 bg-gradient-to-br from-[#E8EEF5]/90 via-[#F4F6F8] to-[#Eef2f7]/80" />
          <div className="absolute -top-24 -right-20 w-[28rem] h-[28rem] rounded-full bg-[#0F2D5C]/[0.04] blur-3xl" />
          <div className="absolute bottom-0 left-0 w-[22rem] h-[22rem] rounded-full bg-[#3B6BA5]/[0.05] blur-3xl" />
        </>
      ) : null}

      {id === "contable_menta" ? (
        <>
          <div className="absolute inset-0 bg-gradient-to-br from-[#F4F6F8] via-[#F2F7F4] to-[#EEF5F1]/90" />
          <div className="absolute -top-16 right-1/4 w-80 h-80 rounded-full bg-[#3DA873]/[0.06] blur-3xl" />
          <div className="absolute -bottom-20 -left-10 w-96 h-72 rounded-full bg-[#0F2D5C]/[0.03] blur-3xl" />
        </>
      ) : null}

      {id === "acceso_suave" ? (
        <>
          <div className="absolute inset-0 bg-[#F4F6F8]" />
          <div className="absolute -top-20 -right-16 w-96 h-96 bg-[#0F2D5C]/[0.06] rotate-12 rounded-md" />
          <div className="absolute top-40 -right-8 w-64 h-44 bg-[#3DA873]/[0.07] -rotate-6 rounded-md" />
          <div className="absolute -bottom-24 -left-12 w-72 h-44 bg-[#3DA873]/[0.05] -rotate-6 rounded-md" />
          <div className="absolute -bottom-28 -right-28 w-96 h-64 bg-[#0F2D5C]/[0.04] rotate-6 rounded-md" />
        </>
      ) : null}
    </div>
  );
}

/** Re-export útil para tests / consumidores. */
export { normalizeAppBackgroundCustom };
